import request from "@utils/request";
export function getConfig(data) {
  return request({
    url: "/hycaner/seriesConfig/noAuth/front/ssh/getSeriesConfig",
    method: "get",
    // noToken: true,
    params: data,
  });
}
